import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-4 overflow-auto" }
const _hoisted_2 = { class: "text-lg leading-6 font-medium text-gray-900" }
const _hoisted_3 = {
  key: 0,
  class: "mt-1 text-sm text-gray-500"
}
const _hoisted_4 = { class: "space-x-2 flex-nowrap flex justify-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormKitSchema = _resolveComponent("FormKitSchema")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FormKit, {
      type: "form",
      "form-class": "bg-white py-6 px-4 space-y-6 sm:p-6",
      onSubmit: _ctx.submit,
      actions: false
    }, {
      default: _withCtx((context) => [
        _createElementVNode("div", null, [
          _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.t("messengerStartChatForm.header")), 1),
          (_ctx.schema.length > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.t("messengerStartChatForm.subHeader")), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_FormKitSchema, { schema: _ctx.schema }, null, 8, ["schema"]),
        _createVNode(_component_FormKit, { type: "submit" }, {
          input: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Button, {
                loading: context.state.loading ?? false,
                onClick: context.node.submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("messengerStartChatForm.startChattingButtonText")), 1)
                ]),
                _: 2
              }, 1032, ["loading", "onClick"])
            ])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}